import React from 'react';
import AuthStore from 'stores/AuthStore';
import ArchivingProfileStore from 'stores/ArchivingProfileStore';
import FilterWordsProfileStore from 'stores/FilterWordsProfileStore';
import CardProfileStore from 'stores/CardProfileStore';
import DepartmentsPage from './DepartmentsPage';
import AltContainer from 'alt-container';
import FilterWordsProfileActions from 'actions/FilterWordsProfileActions';
import CardProfileActions from 'actions/CardProfileActions';
import DepartmentActions from 'actions/department/DepartmentActions';
import DepartmentFormActions from 'actions/DepartmentFormActions';
import DepartmentFormStore from 'stores/department/DepartmentFormStore';
import DepartmentStore from 'stores/department/DepartmentStore';
import ArchivingProfileActions from 'actions/ArchivingProfileActions';

export default class DepartmentsPageContainer extends React.Component {
  componentDidMount() {
    DepartmentActions.fetchDepartmentProfiles();
    ArchivingProfileActions.fetchArchivingProfiles();
    FilterWordsProfileActions.fetchAll();
    CardProfileActions.fetchAll();
  }
  render() {
    return (
      <AltContainer
        stores={{
          ArchivingProfileStore,
          AuthStore,
          CardProfileStore,
          DepartmentFormStore,
          DepartmentStore,
          FilterWordsProfileStore,
        }}
        actions={{DepartmentActions, DepartmentFormActions}}>
        <DepartmentsPage />
      </AltContainer>
    );
  }
}
